define("ember-tag-input/components/tag-input", ["exports", "@ember/component", "@ember/object", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#each this.tags as |tag index|~}}
    <li class="emberTagInput-tag {{tag.modifiers}}">
      {{yield tag}}
      {{#if this._isRemoveButtonVisible}}
        <a class="emberTagInput-remove" {{on 'click' (fn this.removeTag index)}}></a>
      {{/if}}
    </li>
  {{~/each~}}
  
  <li class="emberTagInput-new">
    <input
      disabled={{this.readOnly}}
      class={{concat 'emberTagInput-input js-ember-tag-input-new' (if this.readOnly ' is-disabled')}}
      maxlength={{this.maxlength}}
      placeholder={{this.placeholder}}
      aria-label={{this.ariaLabel}}
    />
  </li>
  
  */
  {
    "id": "lM6sb5Z5",
    "block": "[[[42,[28,[37,1],[[28,[37,1],[[30,0,[\"tags\"]]],null]],null],null,[[[10,\"li\"],[15,0,[29,[\"emberTagInput-tag \",[30,1,[\"modifiers\"]]]]],[12],[1,\"\\n    \"],[18,3,[[30,1]]],[1,\"\\n\"],[41,[30,0,[\"_isRemoveButtonVisible\"]],[[[1,\"      \"],[11,3],[24,0,\"emberTagInput-remove\"],[4,[38,4],[\"click\",[28,[37,5],[[30,0,[\"removeTag\"]],[30,2]],null]],null],[12],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13]],[1,2]],null],[10,\"li\"],[14,0,\"emberTagInput-new\"],[12],[1,\"\\n  \"],[10,\"input\"],[15,\"disabled\",[30,0,[\"readOnly\"]]],[15,0,[28,[37,6],[\"emberTagInput-input js-ember-tag-input-new\",[52,[30,0,[\"readOnly\"]],\" is-disabled\"]],null]],[15,\"maxlength\",[30,0,[\"maxlength\"]]],[15,\"placeholder\",[30,0,[\"placeholder\"]]],[15,\"aria-label\",[30,0,[\"ariaLabel\"]]],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"tag\",\"index\",\"&default\"],false,[\"each\",\"-track-array\",\"yield\",\"if\",\"on\",\"fn\",\"concat\"]]",
    "moduleName": "ember-tag-input/components/tag-input.hbs",
    "isStrictMode": false
  });
  const KEY_CODES = {
    BACKSPACE: 8,
    COMMA: 188,
    ENTER: 13,
    SPACE: 32
  };
  const TAG_CLASS = 'emberTagInput-tag';
  const REMOVE_CONFIRMATION_CLASS = 'emberTagInput-tag--remove';
  let TagInput = _exports.default = (_class = class TagInput extends _component.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "classNameBindings", [':emberTagInput', 'readOnly:emberTagInput--readOnly']);
      _defineProperty(this, "tagName", 'ul');
      _defineProperty(this, "tags", null);
      _defineProperty(this, "removeConfirmation", true);
      _defineProperty(this, "allowCommaInTags", false);
      _defineProperty(this, "allowDuplicates", false);
      _defineProperty(this, "allowSpacesInTags", false);
      _initializerDefineProperty(this, "showRemoveButtons", _descriptor, this);
      _initializerDefineProperty(this, "readOnly", _descriptor2, this);
      _defineProperty(this, "placeholder", '');
      _defineProperty(this, "ariaLabel", '');
      _defineProperty(this, "onKeyUp", false);
    }
    get _isRemoveButtonVisible() {
      return this.showRemoveButtons && !this.readOnly;
    }
    addNewTag(tag) {
      const tags = this.tags;
      const addTag = this.addTag;
      const allowDuplicates = this.allowDuplicates;
      if (!allowDuplicates && tags && tags.indexOf(tag) >= 0) {
        return false;
      }
      return addTag(tag) !== false;
    }
    didInsertElement() {
      super.didInsertElement(...arguments);
      this.initEvents();
    }
    dispatchKeyUp(value) {
      if (this.onKeyUp) {
        this.onKeyUp(value);
      }
    }
    _onContainerClick() {
      const newTagInput = this.element.querySelector('.js-ember-tag-input-new');
      const isReadOnly = this.readOnly;
      if (!isReadOnly) {
        newTagInput.focus();
      }
    }
    _onInputKeyDown(e) {
      if (!this.readOnly) {
        const {
          allowCommaInTags,
          allowSpacesInTags,
          tags
        } = this;
        const backspaceRegex = new RegExp(String.fromCharCode(KEY_CODES.BACKSPACE), 'g');
        const newTag = e.target.value.trim().replace(backspaceRegex, '');
        if (e.which === KEY_CODES.BACKSPACE) {
          if (newTag.length === 0 && tags.length > 0) {
            const removeTagAtIndex = this.removeTagAtIndex;
            if (this.removeConfirmation) {
              const tags = this.element.querySelectorAll('.' + TAG_CLASS);
              const lastTag = tags[tags.length - 1];
              if (lastTag && !lastTag.classList.contains(REMOVE_CONFIRMATION_CLASS)) {
                lastTag.classList.add(REMOVE_CONFIRMATION_CLASS);
                return;
              }
            }
            removeTagAtIndex(tags.length - 1);
          }
        } else {
          if (!allowCommaInTags && e.which === KEY_CODES.COMMA || !allowSpacesInTags && e.which === KEY_CODES.SPACE || e.which === KEY_CODES.ENTER) {
            if (newTag.length > 0) {
              if (this.addNewTag(newTag)) {
                e.target.value = '';
              }
            }
            e.preventDefault();
          }
          [].forEach.call(this.element.querySelectorAll('.' + TAG_CLASS), function (tagEl) {
            tagEl.classList.remove(REMOVE_CONFIRMATION_CLASS);
          });
        }
      }
    }
    _onInputBlur(e) {
      const newTag = e.target.value.trim();
      if (newTag.length > 0) {
        if (this.addNewTag(newTag)) {
          e.target.value = '';
          this.dispatchKeyUp('');
        }
      }
    }
    _onInputKeyUp(e) {
      this.dispatchKeyUp(e.target.value);
    }
    initEvents() {
      const container = this.element;
      const onContainerClick = this._onContainerClick.bind(this);
      const onInputKeyDown = this._onInputKeyDown.bind(this);
      const onInputBlur = this._onInputBlur.bind(this);
      const onInputKeyUp = this._onInputKeyUp.bind(this);
      container.addEventListener('click', onContainerClick);
      const newTagInput = this.element.querySelector('.js-ember-tag-input-new');
      newTagInput.addEventListener('keydown', onInputKeyDown);
      newTagInput.addEventListener('blur', onInputBlur);
      newTagInput.addEventListener('keyup', onInputKeyUp);
    }
    removeTag(index) {
      const removeTagAtIndex = this.removeTagAtIndex;
      removeTagAtIndex(index);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showRemoveButtons", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "readOnly", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "removeTag", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeTag"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TagInput);
});